import {
  BedDouble,
  Bath,
  Users,
  Wifi,
  Tv,
  Snowflake,
  UtensilsCrossed,
  WashingMachine,
  Coffee,
  ArrowUpDown,
} from "lucide-react";

export default function AmenitiesGrid({ features }) {
  const items = [
    { key: "bedrooms", icon: BedDouble, label: "Bedrooms", value: `${features.bedrooms}`, always: true },
    { key: "bathrooms", icon: Bath, label: "Bathrooms", value: `${features.bathrooms}`, always: true },
    { key: "guests", icon: Users, label: "Guests", value: `Up to ${features.guests}`, always: true },
    { key: "wifi", icon: Wifi, label: "High-Speed Wi-Fi", show: features.wifi },
    { key: "smart_tv", icon: Tv, label: "Smart TVs", show: features.smart_tv },
    { key: "ac", icon: Snowflake, label: "Air Conditioning", show: features.ac },
    { key: "kitchen", icon: UtensilsCrossed, label: "Fully Equipped Kitchen", show: features.kitchen },
    { key: "washing_machine", icon: WashingMachine, label: "Washing Machine", show: features.washing_machine },
    { key: "coffee_machine", icon: Coffee, label: "Coffee Machine", show: features.coffee_machine },
    { key: "elevator", icon: ArrowUpDown, label: "Elevator", show: features.elevator },
  ];

  const visible = items.filter((i) => i.always || i.show);

  return (
    <div
      data-testid="amenities-grid"
      className="grid grid-cols-2 md:grid-cols-3 gap-x-6 gap-y-5"
    >
      {visible.map((item) => (
        <div
          key={item.key}
          data-testid={`amenity-${item.key}`}
          className="flex items-center gap-4 py-3 border-b border-[#E5E0D5]/70 last:border-b-0"
        >
          <div className="w-10 h-10 rounded-full bg-[#F7F3EA] flex items-center justify-center shrink-0">
            <item.icon className="w-4 h-4 text-[#C5A059]" strokeWidth={1.5} />
          </div>
          <div className="min-w-0">
            <div className="text-[11px] uppercase tracking-[0.15em] text-[#5C6B4D]">
              {item.label}
            </div>
            {item.value && (
              <div className="text-sm font-medium text-[#2B3324] mt-0.5">
                {item.value}
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
